import { createSlice } from "@reduxjs/toolkit";

export const ShowEditEstateConfigModalSlice = createSlice({
    name: "showEditEstateConfigModal",
    initialState: {
        showEditEstateConfigModal: false,
    },
    reducers: {
        setShowEditEstateConfigModal: (state, action) => {
            state.showEditEstateConfigModal = action.payload;
        }
    }
})

export const { setShowEditEstateConfigModal } = ShowEditEstateConfigModalSlice.actions;

export default ShowEditEstateConfigModalSlice.reducer;